export default __webpack_public_path__ + "static/media/Search Icon.svg";